import store from '@/store';
import storage from '@/plugins/storage';
import { APP_NEW_BRIDGE } from '@/config/app';

export default async (to, from, next) => {
  const { isNewApplicationEnabled } = store.state.user.location;
  const isViewAs = Boolean(store.state.auth.viewAs);
  const isTermsAndDistributionRulesAccepted = store.getters['user/isTermsAndDistributionRulesAccepted'];

  if (
    APP_NEW_BRIDGE
    && isNewApplicationEnabled
    && isTermsAndDistributionRulesAccepted
  ) {
    if (!isViewAs) {
      storage.set('NEW_APP_BY_DEFAULT', true);
    }
    next({ name: 'newapp' });
  } else {
    next();
  }
};
